module.exports = __webpack_public_path__ + "static/img/background02-mercedes-2023.3b42af8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background02-mercedes-2023.jpg
// module id = MemM
// module chunks = 1